import React from 'react'

import { Provider } from 'react-redux'

import { createStore } from 'redux-dynamic-modules';

import { getSagaExtension } from "redux-dynamic-modules-saga";

let store;

const Redux = ({children}) => {
	store = createStore(
		{},
		[],
		[getSagaExtension()]
	);

	return (
		<Provider store={store}>
			{children}
		</Provider>
	)
};

export {
	Redux,
	store
}
